module.exports = __webpack_public_path__ + "img/G.2aba282.webp";